<template>
  <div class="-page">
    <el-tooltip :content="$t('msg.navBar.guide')">
      <svg-icon id="guide-start" icon="guide" @click="onClick"></svg-icon>
    </el-tooltip>
  </div>
</template>

<script setup>
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
import { useI18n } from 'vue-i18n'
import { onMounted } from 'vue'
import steps from './step.js'
const i18n = useI18n()
let driver = null
onMounted(() => {
  driver = new Driver({
    allowClose: false, // 禁止点击蒙版关闭
    closeBtnText: i18n.t('msg.guide.close'), // 关闭按钮
    nextBtnText: i18n.t('msg.guide.next'), // 下一步按钮
    prevBtnText: i18n.t('msg.guide.prev') // 上一步按钮
  })
})
const onClick = () => {
  driver.defineSteps(steps(i18n))
  driver.start()
}
</script>

<style scoped lang="scss"></style>
